export default __webpack_public_path__ + "static/media/tab-all-black.4499832d.svg";